import React from 'react'
import { GetMoneyInputContainer, GetMoneyInputField, GetMoneyLabelText, GetMoneyWrapper } from '../index.styled'
import { getCurrencySymbol } from '../../../../helper'
import { useSelector } from 'react-redux'
import { selectCompanyData } from '../../../../redux/selector/system'
import { useWindowBreakPoint } from '../../../../hooks/useWindowBreakPoint'
import { theme } from '../../../../style/theme'

const GetMoneyInput = React.memo(({ value, textForGetMoneyInput, onChange, onBlur, onFocus }) => {
	const currencyCode = useSelector(selectCompanyData('currency'))
	const isMobile = useWindowBreakPoint(theme.point720)

	return (
		<GetMoneyWrapper>
			<GetMoneyLabelText htmlFor="calculator-sum">{textForGetMoneyInput} ({getCurrencySymbol(currencyCode)})</GetMoneyLabelText>
			<GetMoneyInputContainer>
				<GetMoneyInputField value={value}
														name="calculator-sum"
														readOnly={!isMobile && true}
														onChange={onChange}
														onBlur={onBlur}
														onFocus={onFocus}
														id="calculator-sum"
														inputMode="decimal" />
			</GetMoneyInputContainer>
		</GetMoneyWrapper>

	)

})


GetMoneyInput.displayName = 'GetMoneyInput'
export default GetMoneyInput
